import {
  ITooltipStyleProps,
  ITooltipStyles
} from '@fluentui/react/lib/Tooltip';
import { ITheme } from '@fluentui/react/lib/Styling';

export function getTooltipStyles(themeName: string, _theme: ITheme) {
  return (props: ITooltipStyleProps): Partial<ITooltipStyles> => {
    const { theme } = props;
    const { palette } = theme;

    const styles = {
      content: {
        backgroundColor: palette.white,
        color: palette.black
      }
    };

    // Dark theme overrides
    if (themeName === 'dark') {
      styles.content.backgroundColor = palette.white;
      styles.content.color = palette.black;
    }

    // Contrast theme overrides
    if (themeName === 'contrast') {
      styles.content.backgroundColor = palette.white;
      styles.content.color = palette.black;
    }
    return styles;
  };
}
